
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getNewDateObj from "../../lib/common/getNewDateObj";
import DateSelectForm from "../form/input/DateSelectForm";
import AccessControl from "../functional/AccessControl";
import DailyMaterialPredictionSummaryExcelButton from "../input/DailyStockHistoryExcelButton";
import getSchema from "../../lib/api/getSchema";
import { toKstWallClock } from "../../lib/common/dateFormat";

/**
 * @COMPONENT_NAME DailyMaterialPredictionSummary
 * @DESCRIPTION 일별 품목별 예측 재고 이력 조회 화면
 */

function DailyMaterialPredictionSummary(props) {
    const id = "DailyMaterialPredictionSummary"
    const view = "VwDailyMaterialPredictionSummary"

    const { t } = useTranslation();

    const setNotification = useSetRecoilState(notificationState);

    const today = new Date();

    const [grid, setGrid] = useState();

    const [api, setApi] = useState();

    const [schema, setSchema] = useState();

    const [, setIsEmpty] = useState(true);

    const [searchValues, setSearchValues] = useState({
        materialType: "",
        endTime: getNewDateObj(today),
        startTime: getNewDateObj(today),
    });


    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema(view);
            
            if (mounted) {
                setSchema(schema);
            }

        })();

        return (() => {
            mounted = false;
        });


    }, []);

    useEffect(() => {

        if (searchValues && api) {

            api.refresh();
        }


    }, [searchValues, api])

    const onGridInitialized = (grid) => {

        grid.selectionMode = "Row";

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const onModifyUrl = (url) => {

        let newUrl = `${url}/${toKstWallClock ( searchValues.startTime )}`
        return newUrl;
    };

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }
    const isPastDate = (value) => {
        let date = new Date(value);
        date.setHours(0,0,0,0)

        let today = new Date();
        today.setHours(0,0,0,0)
        
        if(date < today){
            return true;
        }
        
        return false;
    }

    const onChangeCondition1Value = (value) => {
        if(isPastDate(value)) {
            setNotification({ severity: "warning", msg: t("warning.dontChoosePast"), open: true });
            // 칸에 친 지난 날짜를 지우고 조회 중인 날짜로 되돌린다(같은 날의 새 객체라야 날짜 칸이 다시 그려진다)
            setSearchValues((prevValues) => ({ ...prevValues, startTime: new Date(prevValues.startTime) }));
            return;
        }
        setSearchValues((prevValues) => {

            let searchValues = {
                ...prevValues,
                startTime: value,

            };
            return searchValues;
        })


    }

    return (
        <BasicCrudScreenType
            id={id}
            view={view}
            noCreate
            noEdit
            noDelete
            noExcel
            onModifyViewUrl={(url) => onModifyUrl(url)}
            onInitialized={onGridInitialized}
            onApiInitialized={onApiInitialized}
            onLoadData={onLoadData}
            onAppendHeaderAtFirst={() => (
                <>
                    <BasicCrudScreenActionItemLayout>

                        <div style={{ display: "inline-block" }} >
                            <span
                                style={{
                                    display: "inline-block",
                                    height: "16px",
                                    paddingLeft: "15px",
                                    paddingTop: "7px",
                                    marginRight: "2px",
                                }}
                            >
                                조회 일자 :
                            </span>

                            <DateSelectForm
                                id={"DailyStockSummary-condition1-value"}
                                value={searchValues.startTime}
                                onChange={onChangeCondition1Value}
                            />

                        </div>

                    </BasicCrudScreenActionItemLayout>
                </>
            )}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={schema && schema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <DailyMaterialPredictionSummaryExcelButton
                            id={id}
                            view={view}
                            color="primary"
                            searchValues={searchValues}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
        />
    );

}

export default DailyMaterialPredictionSummary;

